import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { useUserSettingsContext } from "../../contexts/Staffing/UserSettingsContext";
import { DailyViewOption } from "../../utils/models";

/** Whether the scheduled Day view shows its Gaps layout. */
export const useIsDayGapsLayout = (): boolean => {
	const { settings } = useUserSettingsContext();
	const { isHospitalView } = useHospitalData();
	// Hospital demos never show the gaps view.
	return settings.dailyView === DailyViewOption.gaps && !isHospitalView;
};
